"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheTopBar = void 0;

var _react = _interopRequireDefault(require("react"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _RocheLogo = _interopRequireDefault(require("../icons/RocheLogo"));

var _core = require("../core");

var _utils = require("../utils");

var _typography = _interopRequireDefault(require("../typography"));

var _topBar = require("./top-bar.style");

var _excluded = ["classes", "title", "position", "elevation", "color", "leftIcon", "rightIcons", "showLogo", "children"],
    _excluded2 = ["leftIcon", "rightIcons", "title", "iconLogo"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The top bar should be fixed on top part of the page. Content is scrollable under this area
 */
var RocheTopBar = function RocheTopBar(props) {
  var classes = props.classes,
      title = props.title,
      position = props.position,
      elevation = props.elevation,
      color = props.color,
      leftIcon = props.leftIcon,
      rightIcons = props.rightIcons,
      showLogo = props.showLogo,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var hasLeftIcon = Boolean(leftIcon);
  var hasRightIcons = Boolean(rightIcons);

  var _mergeClasses = (0, _utils.mergeClasses)((0, _topBar.useStyles)({
    hasRightIcons: hasRightIcons,
    hasLeftIcon: hasLeftIcon
  }), classes),
      leftIconClass = _mergeClasses.leftIcon,
      rightIconsClass = _mergeClasses.rightIcons,
      titleClass = _mergeClasses.title,
      iconLogoClass = _mergeClasses.iconLogo,
      innerClasses = _objectWithoutProperties(_mergeClasses, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: position,
    elevation: elevation,
    color: color
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], _extends({
    classes: innerClasses
  }, rest), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: titleClass
  }, hasLeftIcon && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "left-icon",
    className: leftIconClass
  }, leftIcon), /*#__PURE__*/_react["default"].createElement(_typography["default"], {
    variant: "button",
    color: "inherit"
  }, title)), children, hasRightIcons && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "right-icons",
    className: rightIconsClass
  }, rightIcons), showLogo && /*#__PURE__*/_react["default"].createElement(_RocheLogo["default"], {
    color: "primary",
    className: iconLogoClass
  }))));
};

exports.RocheTopBar = RocheTopBar;
RocheTopBar.displayName = (0, _core.rochePrefix)('TopBar');
RocheTopBar.defaultProps = {
  position: 'absolute',
  elevation: 4,
  variant: 'dense',
  color: 'inherit',
  showLogo: true
};
var _default = RocheTopBar;
exports["default"] = _default;